import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServerRootService } from '@se/platform';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TooluploadService extends ServerRootService {
    //private readonly url = 'http://192.168.72.131/Estensa.Rest/Client/api/vna/Upload';

    readonly boundary: string = '--VNA DATA BOUNDARY';
    readonly newLine: string = '\r\n';
    private readonly vnaEndPoint = '/vna/Upload';
    private readonly url = this.getServerRoot() + this.vnaEndPoint;
    private body1 = 'Content-Type: application/octet-stream';
    private body2 = 'Content-Type: application/json; charset=utf-8';

    constructor(private httpClient: HttpClient) {
        super();
    }

    uploader(fileToLoad: string, body3: any): Observable<any> {
        return this.httpClient.post(
            this.url,
            this.boundary +
                this.newLine +
                this.body1 +
                '\r\n\r\n' +
                fileToLoad +
                this.newLine +
                this.boundary +
                this.newLine +
                this.body2 +
                '\r\n\r\n' +
                body3 +
                this.newLine +
                this.boundary +
                '--',
            {
                reportProgress: true,
                observe: 'events',
                headers: new HttpHeaders({
                    'Content-Type': 'multipart/mixed; boundary="VNA DATA BOUNDARY"',
                }),
            },
        );
    }
}
